import studentApi from "./studentApi";
import { STUDENT_ENDPOINTS } from "./studentEndpoints";

// Confirmed against the shipping mobile app's API client (2026-10-22):
// student_id must be passed explicitly as a flat param — the endpoint 422s
// without it even though the token already identifies the student.
export const getSiblings = async (studentId) => {
  const response = await studentApi.get(STUDENT_ENDPOINTS.SIBLING.GET, { params: { student_id: studentId } });
  return response;
};
